@let texts = resourcesService.languageFile.value();
@let questionState = store.questionState();
@let questionCompleted = store.currentQuestionCompleted();
@let questionIsFinished = (store.questionState().feedback === 'correct') || (store.questionState().feedback === 'wrong-and-over');

<div id="inner-questions-container">
  <p-button (onClick)="showInfo()" [text]="true" class="info-button round-button">
    <img src="assets/icons/info.png" alt="{{texts.gameInstructionsTitle}}">
  </p-button>

  <div class="top-bar desktop-only">
    <div class="attempt-counter">
      {{ texts.attempt }}: {{ questionState.attempt }}/{{ store.maxAttemptsPerQuestion() }}
    </div>
    <div class="score-bar-container">
      <gis-score-bar/>
    </div>
  </div>

  <h1 class="header">{{ store.currentQuestion()?.questionHeader }}</h1>

  <gis-step/>

  <div role="status"> <!-- //NOSONAR -->
    @if (showQuestion) {
      <div class="question">{{ store.currentQuestion()?.question }}</div>
    }
  </div>

  @if (store.phase() === 'playing' && !questionCompleted && showDropdown) {
    <div class="dropdown-container">
      <p-select [options]="store.answerOptions()"
                autofocus
                (onChange)="onDropdownChange($event)"
                optionLabel="label"
                [placeholder]="texts.clickOnMapOrSelectAnswer"
      />
    </div>
  }

  @if (store.guesses().length) {
    <div class="guesses-container" [class.question-completed]="questionIsFinished">
      @for (guess of store.guesses().slice(0, 3); track guess) {
        <div class="guess">
          @if (guess.isCorrect) {
            <span class="check-mark">&check; </span>
          } @else {
            <span>&cross; </span>
          }
          <span>{{ guess.label }}</span>
        </div>
      }
    </div>
  }

  <div class="question-feedback-container desktop-only">
    <gis-question-feedback/>
  </div>

  <div class="hint-container desktop-only">
    <gis-hint [buttonPosition]="'left'"/>
  </div>

  @if (questionIsFinished) {
    <div class="answer-container desktop-only">
      <gis-answer/>
    </div>
  }

  <div class="spacer"></div>

  @if (questionState.feedback === 'correct' || questionState.feedback === 'wrong-and-over') {
    <div class="next-button">
      <p-button (onClick)="nextQuestion()"
                [style]="{width: '100%', display: 'flex', 'align-items': 'center', 'justify-content': 'space-between',
                height: '40px', padding: '8px 20px'}">
        <span>{{
            store.currentQuestion()?.index === store.currentGameQuestions().length - 1
              ? texts.viewScore : texts.nextQuestion
          }}</span>
        <span style="margin-top: 3px"><i class="pi pi-arrow-right"></i></span>
      </p-button>
    </div>
  }

  <div class="stop-button desktop-only">
    @if (!store.error()) {
      <p-button
        (onClick)="onStop()"
        [text]="true"
        [style]="{display: 'flex', 'align-items': 'center', gap: '8px', 'padding-left': 0}">
        <span style="margin-top: 4px"><img src="assets/icons/left-arrow.svg" alt=""></span>
        <span style="color: black">{{ texts.stop }}</span>
      </p-button>
    }
  </div>

  <gm-modal #gmModal
            [title]="texts.gameInstructionsTitle"
            content="{{texts.gameInstructions.join('<br><br>')}}"
            notificationState="{{'information'}}"
            (hide)="hideInfo()"
  ></gm-modal>
</div>
